document.addEventListener('DOMContentLoaded', () => {
  if (!window.quizConfig) return;

  Object.keys(window.quizConfig).forEach((id) => {
    const config = window.quizConfig[id];
    const section = document.querySelector(`#Quiz--${config.sectionId}`);
    if (!section) return;

    const entrance = section.querySelector('.quiz-entrance');
    const steps = Array.from(section.querySelectorAll('.quiz-step'));
    const startBtn = section.querySelector('.quiz-start');
    const globalResultBtn = section.querySelector('#getResultBtn') || section.querySelector('.get-result-btn');
    const defaultUrl = globalResultBtn ? globalResultBtn.getAttribute('href') : '/pages/default-result';

    const totalSteps = steps.length;
    let currentStep = 0;
    const selections = {}; // { stepIndex: value }

    // auto-assign step numbers
    steps.forEach((step, i) => {
      step.dataset.step = i + 1;
    });

    // === load JSON mapping for points-based scoring ===
    let resultMap = {};
    fetch(config.jsonUrl)
      .then((res) => res.json())
      .then((data) => {
        resultMap = data;
        console.log('[quiz] result map loaded', resultMap);
      })
      .catch((err) => console.error('Error loading result map:', err));

    // ---- helper to show step ----
    function showStep(index) {
      steps.forEach((s, i) => s.classList.toggle('active', i === index));
      currentStep = index;
      updateProgress();

      // restore checked state & selected class
      const radios = Array.from(steps[currentStep].querySelectorAll('input[type="radio"]'));
      radios.forEach((r) => {
        const label = r.closest('label');
        if (selections[currentStep] !== undefined && r.value.trim().toLowerCase() === selections[currentStep]) {
          r.checked = true;
          if (label) label.classList.add('selected');
        } else {
          r.checked = false;
          if (label) label.classList.remove('selected');
        }
      });

      // handle result button on last step
      if (currentStep === totalSteps - 1) {
        const allSelected = steps.every((_, i) => selections[i]);
        
          // Compute point totals for each product
          const productScores = {};
          Object.keys(resultMap.questions).forEach((qKey, qIndex) => {
            const answer = selections[qIndex];
            if (!answer) return;
            const answersData = resultMap.questions[qKey][answer];
            if (!answersData) return;
            Object.keys(answersData).forEach((prodKey) => {
              productScores[prodKey] = (productScores[prodKey] || 0) + answersData[prodKey];
            });
          });

          // Pick product with highest score
          let maxScore = -Infinity;
          let selectedProduct = null;
          Object.entries(productScores).forEach(([prodKey, score]) => {
            if (score > maxScore) {
              maxScore = score;
              selectedProduct = prodKey;
            }
          });

          const url = selectedProduct && resultMap.products[selectedProduct] ? resultMap.products[selectedProduct] : defaultUrl;
          window.quizFinalRedirect = url;


          const stepResultBtn = steps[currentStep].querySelector('#getResultBtn, .get-result-btn');
          if (stepResultBtn) {
            stepResultBtn.setAttribute('href', url);
            stepResultBtn.style.display = 'none';
          }
          if (globalResultBtn) {
            globalResultBtn.setAttribute('href', url);
            globalResultBtn.style.display = 'none';
          }
        
      } else {
        // hide buttons for intermediate steps
        const stepResultBtn = steps[currentStep].querySelector('#getResultBtn, .get-result-btn');
        if (stepResultBtn) stepResultBtn.style.display = 'none';
        if (globalResultBtn) globalResultBtn.style.display = 'none';
      }
    }

    // ---- update progress bar ----
    function updateProgress() {
      const bar = steps[currentStep].querySelector('.progress-fill');
      if (!bar) return;
      const progressPercent = ((currentStep + 1) / totalSteps) * 100;
      bar.style.width = `${progressPercent}%`;
    }

    // ---- start button ----
    if (startBtn) {
      startBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (entrance) entrance.classList.add('hidden');
        showStep(0);
      });
    }

    // ---- handle radio selections ----
    steps.forEach((step, index) => {
      const radios = Array.from(step.querySelectorAll('input[type="radio"]'));
      const stepResultBtn = step.querySelector('#getResultBtn, .get-result-btn');

      radios.forEach((radio) => {
        function handleSelection() {
          selections[index] = radio.value.trim().toLowerCase();

          radios.forEach((r) => {
            const lab = r.closest('label');
            if (lab) lab.classList.toggle('selected', r === radio);
          });

          if (window.innerWidth < 769) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }

          if (index < totalSteps - 1) {
            showStep(index + 1);
          } else {
            // Compute point totals for final result (same logic as in showStep)
            const productScores = {};
            Object.keys(resultMap.questions).forEach((qKey, qIndex) => {
              const answer = selections[qIndex];
              if (!answer) return;
              const answersData = resultMap.questions[qKey][answer];
              if (!answersData) return;
              Object.keys(answersData).forEach((prodKey) => {
                productScores[prodKey] = (productScores[prodKey] || 0) + answersData[prodKey];
              });
            });

            let maxScore = -Infinity;
            let selectedProduct = null;
            Object.entries(productScores).forEach(([prodKey, score]) => {
              if (score > maxScore) {
                maxScore = score;
                selectedProduct = prodKey;
              }
            });

            const url = selectedProduct && resultMap.products[selectedProduct] ? resultMap.products[selectedProduct] : defaultUrl;

            window.quizFinalRedirect = url;

            if (stepResultBtn) {
              stepResultBtn.setAttribute('href', url);
              stepResultBtn.style.display = 'inline-block';
            } else if (globalResultBtn) {
              globalResultBtn.setAttribute('href', url);
              globalResultBtn.style.display = 'inline-block';
            }

            console.log('[quiz] selections:', selections, 'final URL:', url);
          }
        }

        radio.addEventListener('change', handleSelection);
        radio.addEventListener('click', () => {
          if (radio.checked) handleSelection();
        });
      });
    });

    // ---- previous button ----
    section.addEventListener('click', (e) => {
      if (e.target.classList.contains('previous_step')) {
        if (currentStep > 0) {
          showStep(currentStep - 1);
        } else {
          if (entrance) entrance.classList.remove('hidden');
          steps.forEach((s) => s.classList.remove('active'));
          if (globalResultBtn) globalResultBtn.style.display = 'none';
          steps.forEach((s) => {
            const btn = s.querySelector('#getResultBtn, .get-result-btn');
            if (btn) {
              btn.style.display = 'none';
              btn.removeAttribute('href');
            }
          });
        }
      }
    });

    // ---- restore pre-selected answers ----
    steps.forEach((step, i) => {
      const pre = step.querySelector('input[type="radio"]:checked');
      if (pre) {
        selections[i] = pre.value.trim().toLowerCase();
        const label = pre.closest('label');
        if (label) label.classList.add('selected');
      }
    });
  });
});
